(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pawlet-personalisierung"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if (customElements.get('pawlet-personalizer')) return;
  const MODES = ['Ohne Text', 'Name', 'Datum', 'Name + Datum'];
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const key = (count, mode) => `${count === 1 ? '1 Tier' : '2 Tiere'} · ${mode}`;
  const parseKey = value => {
    const match = /^(1 Tier|2 Tiere) · (Ohne Text|Name|Datum|Name \+ Datum)$/.exec(value || '');
    return match ? { count: match[1] === '1 Tier' ? 1 : 2, mode: match[2] } : null;
  };
  const node = (tag, cls, text) => {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  const initialPet = i => ({ file: null, image: null, url: null, name: '', birth: '', death: '', x: i ? .68 : .5, y: .42, scale: 1, rotation: 0, loading: false, token: 0 });
  class PawletPersonalizer extends HTMLElement {
    connectedCallback() {
      clearTimeout(this.cleanupTimer);
      if (this.initialized) return;
      requestAnimationFrame(() => { if (this.isConnected && !this.initialized) this.init(); });
    }
    disconnectedCallback() {
      this.cleanupTimer = setTimeout(() => {
        if (this.isConnected) return;
        this.abort?.abort();
        this.resize?.disconnect();
        this.pets?.forEach(p => p.url && URL.revokeObjectURL(p.url));
        cancelAnimationFrame(this.frame);
        this.initialized = false;
      }, 0);
    }
    $(selector) { return this.querySelector(selector); }
    $$(selector) { return [...this.querySelectorAll(selector)]; }
    init() {
      this.initialized = true;
      try {
        this.config = JSON.parse(this.$('[data-pw-config]').textContent);
        this.variants = this.config.variants;
        this.configIndex = this.config.options.findIndex(o => o.name.trim().toLowerCase() === this.config.optionName.trim().toLowerCase());
        if (this.configIndex < 0) throw new Error('Im Produkt fehlt die Variantenoption „' + this.config.optionName + '“. Bitte nach der Einbauanleitung einrichten.');
        if (this.config.variantCount > this.variants.length) throw new Error('Dieses Produkt hat mehr als 250 Varianten. Dieser Block unterstützt bis zu 250 Varianten; bitte den Variantenumfang reduzieren.');
        if (!this.variants.some(v => parseKey(v.options[this.configIndex]))) throw new Error('Die Werte der Personalisierung stimmen noch nicht mit der Einbauanleitung überein.');
        if (this.config.requiresSellingPlan) throw new Error('Dieser Block ist für Einzelkäufe vorgesehen. Bitte die Abo-Pflicht des Produkts deaktivieren.');
        const selected = this.variants.find(v => String(v.id) === String(this.config.selectedId) && parseKey(v.options[this.configIndex])) || this.variants.find(v => v.available && parseKey(v.options[this.configIndex])) || this.variants.find(v => parseKey(v.options[this.configIndex]));
        this.options = [...selected.options];
        const parsed = parseKey(this.options[this.configIndex]);
        this.count = parsed.count; this.mode = parsed.mode;
        this.pets = [initialPet(0), initialPet(1)];
        if (this.count === 2) this.pets[0].x = .32;
        this.active = 0; this.busy = false; this.locked = false;
        this.abort = new AbortController();
        this.canvas = this.$('canvas'); this.ctx = this.canvas.getContext('2d');
        if (!this.ctx || !window.File || !window.FormData || !window.crypto?.getRandomValues) throw new Error('Bitte einen aktuellen Browser verwenden, damit Fotos und Vorschau übertragen werden können.');
        this.money = new Intl.NumberFormat(this.config.locale || 'de-DE', { style: 'currency', currency: this.config.currency || 'EUR' });
        this.colors = new Map();
        String(this.config.colors || '').replace(/\\n/g, '\n').split('\n').forEach(line => {
          const divider = line.lastIndexOf(':');
          const name = line.slice(0, divider).trim(); const color = line.slice(divider + 1).trim();
          if (divider > 0 && /^#[0-9a-f]{6}$/i.test(color)) this.colors.set(name.toLowerCase(), color);
        });
        this.renderVariants(); this.renderChoices(); this.renderPets(); this.bind(); this.sync();
        this.$('[data-setup]').hidden = true; this.$('[data-app]').hidden = false;
        this.media = matchMedia('(min-width: 750px)');
        this.media.addEventListener('change', () => this.placeEditor(), { signal: this.abort.signal });
        this.placeEditor();
        this.resize = new ResizeObserver(() => this.scheduleDraw()); this.resize.observe(this.canvas);
      } catch (error) { this.$('[data-setup]').textContent = error.message; }
    }
    listen(target, type, callback, options = {}) { target.addEventListener(type, callback, { ...options, signal: this.abort.signal }); }
    bind() {
      this.listen(this, 'click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button) || button.disabled) return;
        if (button.hasAttribute('data-close')) return this.close();
        if (button.hasAttribute('data-open')) return this.open();
        if (this.busy || this.locked) return;
        if (button.hasAttribute('data-buy')) return this.addToCart();
        if (button.dataset.optionIndex !== undefined) {
          this.options[Number(button.dataset.optionIndex)] = button.dataset.optionValue;
          this.clearError(); this.sync();
        } else if (button.dataset.count) {
          const next = Number(button.dataset.count);
          if (next !== this.count) {
            // Only default positions move automatically. Deliberately edited positions survive.
            if (!this.pets[0].positionEdited) this.pets[0].x = next === 1 ? .5 : .32;
            this.count = next; this.active = Math.min(this.active, next - 1);
          }
          this.clearError(); this.sync();
        } else if (button.dataset.mode) { this.mode = button.dataset.mode; this.clearError(); this.sync(); }
        else if (button.dataset.activePet !== undefined) { this.active = Number(button.dataset.activePet); this.syncTransforms(); this.scheduleDraw(); }
        else if (button.hasAttribute('data-reset')) {
          const pet = this.pets[this.active];
          Object.assign(pet, { x: this.count === 1 ? .5 : this.active ? .68 : .32, y: .42, scale: 1, rotation: 0, positionEdited: false });
          this.syncTransforms(); this.scheduleDraw();
        }
      });
      this.listen(this, 'change', event => {
        const input = event.target;
        if (input.dataset.file !== undefined) this.loadPhoto(Number(input.dataset.file), input.files[0]);
      });
      this.listen(this, 'input', event => {
        if (this.busy || this.locked) return;
        const input = event.target;
        if (input.dataset.petField) {
          this.pets[Number(input.dataset.petIndex)][input.dataset.petField] = input.value;
          this.clearError(); this.syncSummary(); this.scheduleDraw();
        }
        if (input.dataset.transform) {
          const field = input.dataset.transform;
          this.pets[this.active][field] = Number(input.value) / (field === 'rotation' ? 1 : 100);
          this.pets[this.active].positionEdited = true;
          this.syncTransforms(); this.scheduleDraw();
        }
      });
      this.listen(this.$('[data-dialog]'), 'cancel', event => { if (this.busy) event.preventDefault(); });
      this.listen(this.canvas, 'pointerdown', event => this.pointerDown(event));
      this.listen(this.canvas, 'pointermove', event => {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        const p = this.point(event); const pet = this.pets[this.active];
        pet.x = clamp(p.x - this.drag.dx, 0, 1); pet.y = clamp(p.y - this.drag.dy, 0, .78); pet.positionEdited = true;
        this.syncTransforms(); this.scheduleDraw();
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => this.listen(this.canvas, type, () => { this.drag = null; }));
      this.listen(this.canvas, 'keydown', event => {
        if (this.busy || this.locked || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
        event.preventDefault(); const p = this.pets[this.active], step = event.shiftKey ? .05 : .01;
        if (event.key === 'ArrowLeft') p.x = clamp(p.x - step, 0, 1);
        if (event.key === 'ArrowRight') p.x = clamp(p.x + step, 0, 1);
        if (event.key === 'ArrowUp') p.y = clamp(p.y - step, 0, .78);
        if (event.key === 'ArrowDown') p.y = clamp(p.y + step, 0, .78);
        p.positionEdited = true; this.syncTransforms(); this.scheduleDraw();
      });
    }
    placeEditor() {
      const inline = this.media.matches && this.dataset.desktop === 'inline';
      const dialog = this.$('[data-dialog]');
      if (dialog.open && inline) dialog.close();
      (inline ? this.$('[data-inline]') : dialog).append(this.$('[data-editor]'));
      this.$('[data-open]').hidden = inline;
      this.scheduleDraw();
    }
    open() { const dialog = this.$('[data-dialog]'); if (!dialog.open) dialog.showModal(); this.scheduleDraw(); }
    close() { if (!this.busy) this.$('[data-dialog]').close(); }
    variant(count = this.count, mode = this.mode, options = this.options) {
      const target = [...options]; target[this.configIndex] = key(count, mode);
      return this.variants.find(v => v.options.every((value, i) => value === target[i]));
    }
    format(cents) { return this.money.format(cents / 100); }
    delta(cents) { return cents === 0 ? 'Inklusive' : (cents > 0 ? '+' : '−') + this.format(Math.abs(cents)); }
    color(value) { return this.colors.get(String(value).toLowerCase()) || null; }
    renderVariants() {
      const root = this.$('[data-variants]'); root.replaceChildren();
      this.config.options.forEach((option, index) => {
        if (index === this.configIndex) return;
        const group = node('div'); const label = node('div', 'pw__variant-label');
        label.append(node('strong', '', option.name), node('span', '', this.options[index]));
        label.dataset.variantLabel = String(index); group.append(label);
        const swatches = option.values.every(value => this.color(value));
        const buttons = node('div', 'pw__variant-buttons' + (swatches ? ' pw__swatches' : ''));
        buttons.setAttribute('role', 'group'); buttons.setAttribute('aria-label', option.name);
        option.values.forEach(value => {
          const button = node('button'); button.type = 'button'; button.dataset.optionIndex = String(index); button.dataset.optionValue = value;
          if (swatches) { const dot = node('i'); dot.style.setProperty('--swatch', this.color(value)); dot.setAttribute('aria-hidden', 'true'); button.append(dot); button.setAttribute('aria-label', value); button.title = value; }
          else button.textContent = value;
          buttons.append(button);
        }); group.append(buttons); root.append(group);
      });
    }
    renderChoices() {
      const make = (text, dataName, dataValue) => {
        const button = node('button', 'pw__choice'); button.type = 'button'; button.dataset[dataName] = dataValue;
        button.append(node('strong', '', text), node('small', '', '')); return button;
      };
      this.$('[data-counts]').replaceChildren(make('1 Tier', 'count', '1'), make('2 Tiere', 'count', '2'));
      this.$('[data-modes]').replaceChildren(...MODES.map(mode => make(mode, 'mode', mode)));
    }
    renderPets() {
      const root = this.$('[data-pets]'); root.replaceChildren();
      this.pets.forEach((pet, i) => {
        const section = node('div', 'pw__pet'); section.dataset.pet = String(i);
        section.append(node('h3', '', i === 0 ? '3  Dein Foto & deine Angaben' : 'Dein zweites Tier'));
        const label = node('label', 'pw__upload');
        const icon = node('span', 'pw__upload-icon', '↑'); icon.setAttribute('aria-hidden', 'true');
        const text = node('span'); text.append(node('strong', '', `Foto für Tier ${i + 1} auswählen`), node('small', '', 'JPG, PNG oder WebP · max. 10 MB'));
        const input = node('input', 'pw__file'); input.type = 'file'; input.accept = 'image/jpeg,image/png,image/webp'; input.dataset.file = String(i); input.setAttribute('aria-label', `Foto für Tier ${i + 1}`);
        label.append(icon, text, input); section.append(label);
        const fields = node('div', 'pw__fields');
        const field = (property, title, type) => {
          const wrap = node('label', 'pw__field', title); wrap.dataset.fieldWrap = property;
          const el = node('input'); el.type = type; el.dataset.petIndex = String(i); el.dataset.petField = property; el.value = pet[property];
          if (type === 'text') { el.maxLength = 24; el.placeholder = i ? 'z. B. Luna' : 'z. B. Buddy'; el.autocomplete = 'off'; }
          wrap.append(el); return wrap;
        };
        fields.append(field('name', 'Name deines Lieblings', 'text'));
        const dates = node('div', 'pw__date-fields'); dates.dataset.dates = '';
        dates.append(field('birth', 'Geburtsdatum', 'date'), field('death', 'Sterbedatum', 'date')); fields.append(dates);
        const hint = node('small', 'pw__hint', 'Ein Datum genügt. Bitte trage nur die gewünschten Daten ein.'); hint.dataset.dateHint = ''; fields.append(hint);
        section.append(fields); root.append(section);
      });
      this.$('[data-active-pets]').replaceChildren(...this.pets.map((_, i) => {
        const button = node('button', '', `Tier ${i + 1} bewegen`); button.type = 'button'; button.dataset.activePet = String(i); return button;
      }));
    }
    sync() {
      this.options[this.configIndex] = key(this.count, this.mode);
      this.current = this.variant();
      const base = this.variant(1, 'Ohne Text'); const withoutText = this.variant(this.count, 'Ohne Text');
      this.validPricing = !!(base && withoutText && this.current);
      this.$$('[data-total]').forEach(el => { el.textContent = this.current ? this.format(this.current.price) : 'Nicht verfügbar'; });
      this.$$('[data-option-index]').forEach(button => {
        const i = Number(button.dataset.optionIndex), options = [...this.options]; options[i] = button.dataset.optionValue;
        const possible = this.variant(this.count, this.mode, options);
        button.setAttribute('aria-pressed', String(this.options[i] === button.dataset.optionValue));
        // Keep choices reachable even when a different combination is currently unavailable.
        button.title = button.dataset.optionValue + (!possible?.available ? ' – für die aktuelle Kombination nicht verfügbar' : '');
      });
      this.$$('[data-variant-label]').forEach(label => { label.lastElementChild.textContent = this.options[Number(label.dataset.variantLabel)]; });
      this.$$('[data-count]').forEach(button => {
        const count = Number(button.dataset.count), target = this.variant(count, this.mode), baseline = this.variant(1, this.mode);
        button.setAttribute('aria-pressed', String(count === this.count));
        button.disabled = !target?.available || !baseline;
        button.lastElementChild.textContent = target && baseline ? this.delta(target.price - baseline.price) : 'Nicht verfügbar';
        if (target && !target.available) button.lastElementChild.textContent = 'Ausverkauft';
      });
      this.$$('[data-mode]').forEach(button => {
        const target = this.variant(this.count, button.dataset.mode);
        button.setAttribute('aria-pressed', String(button.dataset.mode === this.mode));
        button.disabled = !target?.available || !withoutText;
        button.lastElementChild.textContent = target && withoutText ? this.delta(target.price - withoutText.price) : 'Nicht verfügbar';
        if (target && !target.available) button.lastElementChild.textContent = 'Ausverkauft';
      });
      this.$$('[data-pet]').forEach((section, i) => {
        section.hidden = i >= this.count;
        section.querySelector('[data-field-wrap="name"]').hidden = !this.mode.includes('Name');
        section.querySelector('[data-dates]').hidden = !this.mode.includes('Datum');
        section.querySelector('[data-date-hint]').hidden = !this.mode.includes('Datum');
        section.querySelectorAll('[data-pet-field]').forEach(input => {
          input.disabled = i >= this.count || (input.dataset.petField === 'name' ? !this.mode.includes('Name') : !this.mode.includes('Datum'));
        });
      });
      const breakdown = this.$('[data-breakdown]'); breakdown.replaceChildren();
      if (this.validPricing) {
        breakdown.append(node('span', '', `Portrait ${this.format(base.price)}`));
        if (this.count === 2) breakdown.append(node('span', '', `2. Tier ${this.delta(withoutText.price - base.price)}`));
        if (this.mode !== 'Ohne Text') breakdown.append(node('span', '', `${this.mode} ${this.delta(this.current.price - withoutText.price)}`));
      }
      this.syncButton(); this.syncTransforms(); this.syncSummary(); this.updateCanvasSize(); this.scheduleDraw();
    }
    syncButton() {
      const button = this.$('[data-buy]');
      button.disabled = this.busy || this.locked || !this.validPricing || !this.current?.available || this.pets.slice(0, this.count).some(p => p.loading);
      button.textContent = this.busy ? 'Fotos werden übertragen …' : this.locked ? 'Bitte Warenkorb prüfen' : !this.current?.available ? 'Nicht verfügbar' : 'In den Warenkorb →';
    }
    syncSummary() {
      const names = this.mode.includes('Name') ? this.pets.slice(0, this.count).map(p => p.name.trim()).filter(Boolean).join(' & ') : '';
      this.$('[data-summary]').textContent = `${this.count === 1 ? '1 Tier' : '2 Tiere'} · ${this.mode}${names ? ' · ' + names : ''}`;
    }
    syncTransforms() {
      const p = this.pets[this.active];
      this.$$('[data-transform]').forEach(input => { const field = input.dataset.transform; input.value = Math.round(p[field] * (field === 'rotation' ? 1 : 100)); });
      this.$('[data-output="scale"]').textContent = Math.round(p.scale * 100) + '%';
      this.$('[data-output="rotation"]').textContent = p.rotation + '°';
      this.$$('[data-active-pet]').forEach((button, i) => { button.hidden = i >= this.count; button.setAttribute('aria-pressed', String(i === this.active)); });
    }
    async loadPhoto(index, file) {
      if (!file || this.busy || this.locked) return;
      const pet = this.pets[index], token = ++pet.token;
      const input = this.$(`[data-file="${index}"]`);
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024 || file.size === 0) {
        input.value = ''; pet.loading = false; this.syncButton(); this.showError('Bitte ein JPG-, PNG- oder WebP-Foto mit maximal 10 MB auswählen.'); return;
      }
      const url = URL.createObjectURL(file); pet.loading = true; this.syncButton();
      try {
        const image = new Image(); image.src = url; await image.decode();
        if (pet.token !== token || !this.isConnected) { URL.revokeObjectURL(url); return; }
        if (!image.naturalWidth || !image.naturalHeight || image.naturalWidth * image.naturalHeight > 50000000) throw new Error('Bitte ein Foto mit höchstens 50 Megapixeln verwenden.');
        if (pet.url) URL.revokeObjectURL(pet.url);
        Object.assign(pet, { file, image, url });
        const label = input.closest('label'); label.querySelector('strong').textContent = `Foto für Tier ${index + 1} ändern`;
        label.querySelector('small').textContent = file.name + ' · ausgewählt';
        this.active = index; this.clearError(); this.syncTransforms(); this.scheduleDraw();
        if (Math.min(image.naturalWidth, image.naturalHeight) < 700) label.querySelector('small').textContent += ' · geringe Auflösung; ein größeres Foto ist besser';
      } catch (error) {
        URL.revokeObjectURL(url); input.value = '';
        if (pet.token === token) this.showError(error.message.includes('Megapixel') ? error.message : 'Dieses Foto konnte nicht gelesen werden. Bitte erneut als JPG oder PNG speichern.');
      } finally { if (pet.token === token) { pet.loading = false; this.syncButton(); } }
    }
    updateCanvasSize() {
      let ratio = .75;
      for (let i = 0; i < this.options.length; i++) {
        if (i === this.configIndex) continue;
        const match = String(this.options[i]).match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
        if (match) { const a = Number(match[1].replace(',', '.')), b = Number(match[2].replace(',', '.')); if (a > 0 && b > 0) ratio = clamp(a / b, .4, 2); }
      }
      const h = Math.round(900 / ratio);
      if (this.canvas.height !== h) { this.canvas.width = 900; this.canvas.height = h; }
    }
    background() { return this.options.map(value => this.color(value)).find(Boolean) || '#e3ddd4'; }
    geometry(p, width, height) {
      const maxW = width * (this.count === 1 ? .83 : .55), maxH = height * .63;
      const ratio = p.image ? p.image.naturalWidth / p.image.naturalHeight : .83;
      let w = maxW, h = w / ratio;
      if (h > maxH) { h = maxH; w = h * ratio; }
      return { x: p.x * width, y: p.y * height, w: w * p.scale, h: h * p.scale };
    }
    dateText(p) {
      const format = value => value ? value.split('-').reverse().join('.') : '';
      return [p.birth ? '✶ ' + format(p.birth) : '', p.death ? '† ' + format(p.death) : ''].filter(Boolean).join('   ');
    }
    draw(ctx, width, height, editing = true) {
      ctx.clearRect(0, 0, width, height); ctx.fillStyle = '#fffdf9'; ctx.fillRect(0, 0, width, height);
      const gradient = ctx.createRadialGradient(width * .5, height * .4, width * .04, width * .5, height * .4, width * .7);
      gradient.addColorStop(0, this.background() + '99'); gradient.addColorStop(.65, this.background() + '38'); gradient.addColorStop(1, this.background() + '00');
      ctx.fillStyle = gradient; ctx.fillRect(0, 0, width, height);
      this.pets.slice(0, this.count).forEach((pet, i) => {
        const box = this.geometry(pet, width, height);
        ctx.save(); ctx.translate(box.x, box.y); ctx.rotate(pet.rotation * Math.PI / 180);
        if (pet.image) ctx.drawImage(pet.image, -box.w / 2, -box.h / 2, box.w, box.h);
        else {
          ctx.fillStyle = '#ffffffa6'; ctx.fillRect(-box.w / 2, -box.h / 2, box.w, box.h);
          ctx.strokeStyle = '#ba9c8870'; ctx.lineWidth = width * .002; ctx.setLineDash([width * .009, width * .01]); ctx.strokeRect(-box.w / 2, -box.h / 2, box.w, box.h); ctx.setLineDash([]);
          ctx.fillStyle = '#9b7967'; ctx.textAlign = 'center'; ctx.font = `${Math.round(width * .053)}px Georgia, serif`; ctx.fillText('Dein Liebling', 0, 0);
          ctx.font = `${Math.round(width * .023)}px Arial, sans-serif`; ctx.fillText(this.count === 2 ? `Foto ${i + 1} auswählen` : 'Hier beginnt dein Unikat', 0, width * .05);
        }
        if (editing && pet.image && i === this.active) { ctx.strokeStyle = '#ad7068'; ctx.lineWidth = width * .002; ctx.setLineDash([width * .008, width * .006]); ctx.strokeRect(-box.w / 2, -box.h / 2, box.w, box.h); }
        ctx.restore();
      });
      const hasText = this.mode !== 'Ohne Text';
      if (hasText) {
        ctx.fillStyle = '#fffdf9e8'; ctx.fillRect(0, height * .79, width, height * .21);
        this.pets.slice(0, this.count).forEach((pet, i) => {
          const x = this.count === 1 ? width / 2 : width * (i ? .73 : .27), maxWidth = width * (this.count === 1 ? .84 : .42);
          ctx.fillStyle = '#35251e'; ctx.textAlign = 'center';
          if (this.mode.includes('Name')) {
            const name = pet.name.trim() || (editing ? `Name ${i + 1}` : '');
            let size = width * (this.count === 1 ? .084 : .063);
            ctx.font = `${size}px Georgia, serif`;
            while (ctx.measureText(name).width > maxWidth && size > width * .016) { size -= 1; ctx.font = `${size}px Georgia, serif`; }
            ctx.fillText(name, x, height * .865);
          }
          if (this.mode.includes('Datum')) {
            ctx.fillStyle = '#756255'; ctx.font = `${Math.round(width * (this.count === 1 ? .026 : .022))}px Arial, sans-serif`;
            ctx.fillText(this.dateText(pet) || (editing ? 'Dein Erinnerungsdatum' : ''), x, height * (this.mode.includes('Name') ? .913 : .87), maxWidth);
          }
        });
      }
    }
    scheduleDraw() { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => { if (this.ctx) this.draw(this.ctx, this.canvas.width, this.canvas.height); }); }
    point(event) {
      const rect = this.canvas.getBoundingClientRect(), style = getComputedStyle(this.canvas);
      const bx = parseFloat(style.borderLeftWidth) || 0, by = parseFloat(style.borderTopWidth) || 0;
      return { x: (event.clientX - rect.left - bx) / (rect.width - 2 * bx), y: (event.clientY - rect.top - by) / (rect.height - 2 * by) };
    }
    pointerDown(event) {
      if (this.busy || this.locked || event.button !== 0 || this.drag) return;
      const point = this.point(event);
      for (let i = this.count - 1; i >= 0; i--) {
        const pet = this.pets[i]; if (!pet.image) continue;
        const b = this.geometry(pet, this.canvas.width, this.canvas.height), a = -pet.rotation * Math.PI / 180;
        const dx = point.x * this.canvas.width - b.x, dy = point.y * this.canvas.height - b.y;
        if (Math.abs(dx * Math.cos(a) - dy * Math.sin(a)) <= b.w / 2 && Math.abs(dx * Math.sin(a) + dy * Math.cos(a)) <= b.h / 2) {
          this.active = i; this.drag = { id: event.pointerId, dx: point.x - pet.x, dy: point.y - pet.y };
          this.canvas.setPointerCapture(event.pointerId); this.canvas.focus({ preventScroll: true }); this.syncTransforms(); this.scheduleDraw(); return;
        }
      }
    }
    showError(text) { const el = this.$('[data-error]'); el.hidden = false; el.textContent = text; }
    clearError() { if (!this.locked) { this.$('[data-error]').hidden = true; this.$('[data-error]').textContent = ''; } }
    validate() {
      if (!this.validPricing || !this.current?.available) return 'Diese Kombination ist aktuell nicht verfügbar. Bitte wähle eine andere Option.';
      for (let i = 0; i < this.count; i++) {
        const pet = this.pets[i];
        if (pet.loading) return 'Bitte warte kurz, bis dein Foto geladen ist.';
        if (!pet.file || !pet.image) return `Bitte lade ein Foto für Tier ${i + 1} hoch.`;
        if (this.mode.includes('Name') && !pet.name.trim()) return `Bitte trage den Namen für Tier ${i + 1} ein.`;
        if (this.mode.includes('Datum')) {
          if (!pet.birth && !pet.death) return `Bitte trage für Tier ${i + 1} mindestens ein Datum ein.`;
          for (const date of [pet.birth, pet.death].filter(Boolean)) {
            const parsed = new Date(date + 'T00:00:00Z');
            if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date) return `Bitte prüfe die Datumsangaben für Tier ${i + 1}.`;
          }
          if (pet.birth && pet.death && pet.death < pet.birth) return `Das Sterbedatum von Tier ${i + 1} liegt vor dem Geburtsdatum. Bitte prüfen.`;
        }
      }
      return null;
    }
    async previewFile() {
      const canvas = document.createElement('canvas'); canvas.width = 1600; canvas.height = Math.round(1600 * this.canvas.height / this.canvas.width);
      this.draw(canvas.getContext('2d'), canvas.width, canvas.height, false);
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', .9));
      if (!blob) throw new Error('Die Vorschau konnte nicht erstellt werden. Bitte erneut versuchen.');
      return new File([blob], 'Pawlet-Layoutvorschau.jpg', { type: 'image/jpeg' });
    }
    async request(url, options = {}, milliseconds = 90000) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), milliseconds);
      try { return await fetch(url, { ...options, signal: controller.signal }); }
      finally { clearTimeout(timer); }
    }
    layout() {
      return { version: 'pawlet-layout-1.0', description: 'Layoutreferenz mit Originalfotos; keine fertige Aquarell- oder Druckdatei.', variantId: this.current.id, options: this.options, count: this.count, mode: this.mode, canvas: { width: this.canvas.width, height: this.canvas.height }, background: this.background(), photoFit: { maxWidth: this.count === 1 ? .83 : .55, maxHeight: .63 }, text: { font: 'Georgia', nameY: .865, dateY: this.mode.includes('Name') ? .913 : .87 }, pets: this.pets.slice(0, this.count).map((pet, i) => ({ number: i + 1, originalFilename: pet.file.name, originalWidth: pet.image.naturalWidth, originalHeight: pet.image.naturalHeight, name: this.mode.includes('Name') ? pet.name.trim() : '', birth: this.mode.includes('Datum') ? pet.birth : '', death: this.mode.includes('Datum') ? pet.death : '', x: pet.x, y: pet.y, scale: pet.scale, rotationDegrees: pet.rotation })) };
    }
    async addToCart() {
      if (this.busy || this.locked) return;
      const error = this.validate();
      if (error) { this.showError(error); this.$('[data-error]').focus(); return; }
      this.clearError(); this.busy = true; this.dataset.busy = 'true'; this.syncButton();
      this.$('[data-close]').disabled = true;
      const editor = this.$('.pw__workspace'), variants = this.$('[data-variants]');
      editor.inert = true; variants.inert = true;
      let sent = false;
      const orderId = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : [...crypto.getRandomValues(new Uint8Array(16))].map(n => n.toString(16).padStart(2, '0')).join('');
      try {
        const preview = await this.previewFile();
        const data = new FormData(); data.append('id', String(this.current.id)); data.append('quantity', '1');
        const property = (name, value) => data.append(`properties[${name}]`, value);
        property('_Pawlet-ID', orderId); property('Tieranzahl', String(this.count)); property('Beschriftung', this.mode);
        const expectedFiles = ['Layoutvorschau'];
        property('Layoutvorschau', preview);
        property('_Pawlet-Layoutversion', '1.0');
        property('_Pawlet-Layoutformat', `${this.canvas.width} x ${this.canvas.height} px; Ursprung links oben; Positionen = Fotomitte`);
        property('_Pawlet-Fotoflaeche', `Einpassen in ${this.count === 1 ? 83 : 55} % Breite / 63 % Höhe, dann skalieren und um Fotomitte drehen`);
        property('_Pawlet-Hintergrund', this.background());
        this.pets.slice(0, this.count).forEach((pet, i) => {
          const prefix = `Tier ${i + 1}`; property(prefix + ' Originalfoto', pet.file); expectedFiles.push(prefix + ' Originalfoto');
          if (this.mode.includes('Name')) property(prefix + ' Name', pet.name.trim());
          if (this.mode.includes('Datum')) { if (pet.birth) property(prefix + ' Geburtsdatum', pet.birth.split('-').reverse().join('.')); if (pet.death) property(prefix + ' Sterbedatum', pet.death.split('-').reverse().join('.')); }
          property(prefix + ' Bildposition', `X ${(pet.x * 100).toFixed(2)} %; Y ${(pet.y * 100).toFixed(2)} %; Größe ${(pet.scale * 100).toFixed(0)} %; Drehung ${pet.rotation}°`);
        });
        this.pending = { id: orderId, expectedFiles };
        const root = this.config.root || '/';
        sent = true;
        // Multipart is intentional: JSON would turn the uploaded files into unusable metadata.
        const response = await this.request(root + 'cart/add.js', { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'application/json' } });
        let result;
        try { result = await response.json(); } catch (_) { throw new Error('Shopify hat keine lesbare Antwort geliefert.'); }
        if (!response.ok) {
          if (response.status >= 400 && response.status < 500 && response.status !== 408) {
            sent = false;
            throw new Error(typeof result.description === 'string' ? result.description : 'Shopify konnte diese Auswahl nicht hinzufügen. Bitte Verfügbarkeit und Fotos prüfen.');
          }
          throw new Error('Die Übertragung konnte nicht bestätigt werden.');
        }
        const item = result.items?.find(item => item.properties?.['_Pawlet-ID'] === orderId) || result;
        this.finish(item, expectedFiles);
      } catch (err) {
        if (sent) {
          // Never repeat an ambiguous add: the server might already have created the cart line.
          let found;
          try {
            const response = await this.request((this.config.root || '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }, 10000);
            if (response.ok) found = (await response.json()).items?.find(item => item.properties?.['_Pawlet-ID'] === orderId);
          } catch (_) { /* Preserve the ambiguous state instead of creating a duplicate. */ }
          if (found) this.finish(found, this.pending.expectedFiles);
          else { this.locked = true; this.showError('Die Übertragung konnte nicht eindeutig bestätigt werden. Bitte prüfe zuerst den Warenkorb, bevor du dieses Portrait erneut hinzufügst.'); this.$('[data-cart-link]').hidden = false; }
        } else this.showError(err.message || 'Bitte überprüfe deine Auswahl und versuche es erneut.');
      } finally {
        this.busy = false; this.dataset.busy = 'false'; editor.inert = this.locked; variants.inert = this.locked;
        this.$('[data-close]').disabled = false; this.syncButton();
      }
    }
    finish(item, expectedFiles) {
      this.locked = true;
      const isLink = value => typeof value === 'string' && (/^https:\/\//i.test(value) || value.startsWith('//') || value.startsWith('/uploads/'));
      const complete = expectedFiles.every(name => isLink(item.properties?.[name]));
      if (!complete) {
        this.showError('Der Artikel liegt im Warenkorb, aber Shopify hat nicht alle Dateilinks bestätigt. Bitte diesen Artikel dort entfernen und die Personalisierung erneut durchführen. Bei erneutem Fehler kontaktiere uns.');
        this.$('[data-cart-link]').hidden = false; return;
      }
      window.location.assign(this.config.cartUrl || '/cart');
    }
  }
  customElements.define('pawlet-personalizer', PawletPersonalizer);
})();
  } catch(e) { console.error(e); }
})();

})();
